/**
 * "Join The Circle" buttons → Klaviyo sign-up form.
 *
 * Mirrors the main theme's inline handler exactly:
 *   window._klOnsite = window._klOnsite || [];
 *   window._klOnsite.push(['openForm', 'WHjLwE']);
 *   return false;
 *
 * Config comes from snippets/klaviyo-form-trigger.liquid.
 */
(function () {
  const config = window.klaviyoFormTrigger;
  if (!config || !config.enabled || !config.formId || !config.selector) return;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(config.selector);
    if (!trigger) return;

    // A per-element data attribute wins, so one page can open several forms.
    const formId = trigger.dataset.klaviyoForm || config.formId;
    if (!formId) return;

    event.preventDefault();

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
})();
